<div class="container" [style.paddingBottom]="settings? settings.topPaddingEm+'em': '1em'" [style.paddingTop]="settings? settings.topPaddingEm+'em': '1em'">
  <a [routerLink]="[href]" class="box" [style.backgroundColor]='settings? settings.primaryColor : "#fff"'
     [contrastForeground]="settings.primaryColor">
    <div class="title" [style.fontFamily]="settings.fontTitle">{{text}}</div>
    <fa-icon class="icon" icon="chevron-down"></fa-icon>
  </a>
</div>


